import { createIcon, LinkBox, LinkBoxProps, LinkOverlay, Text } from '@chakra-ui/react';

import { trackEvent } from '~/features/analytics/track-event';
import { usePromotion } from '~/features/promotions/hooks/use-promotion';

// Plans-specific duplicate of `PromotionsBanner` (inline variant). The shared
// `PromotionsBanner` is also rendered on the `/ai` page where it must keep
// firing `Product Page CTA Clicked`; this copy lets the plans page report
// `Plans CTA Clicked` without affecting that surface. Keep the inline layout
// in sync with the original.
const PersonalizedDiscountIcon = createIcon({
  displayName: 'PersonalizedDiscountIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      d='M12.0022 1.73316C11.349 1.73316 10.6954 1.91241 10.1194 2.27005L9.03956 2.94192L7.76786 3.0335C6.4163 3.13246 5.23487 3.9914 4.72272 5.24661L4.24269 6.4263L3.2696 7.24661C2.23401 8.12074 1.78218 9.5105 2.10553 10.8269L2.41022 12.063L2.10553 13.2991C1.78175 14.6147 2.23444 16.0044 3.2696 16.8794L4.24269 17.6997L4.72272 18.8794C5.23401 20.1355 6.4163 20.9936 7.76786 21.0925L9.03956 21.1841L10.1194 21.856C11.2709 22.5704 12.7336 22.5704 13.885 21.856L14.9653 21.1841L16.2366 21.0925C17.5882 20.9936 18.7696 20.1346 19.2818 18.8794L19.7622 17.6997L20.7349 16.8794C21.7705 16.0053 22.2223 14.6155 21.8985 13.2991L21.5943 12.063L21.8985 10.8269C22.2227 9.51137 21.77 8.12161 20.7349 7.24661L19.7622 6.42413L19.2818 5.24661C18.7705 3.99053 17.5882 3.13246 16.2366 3.0335L14.9653 2.93975L13.885 2.26788C13.3091 1.91111 12.6554 1.73272 12.0022 1.73316ZM12.0022 3.23099C12.3803 3.23099 12.7587 3.33559 13.0942 3.54349L14.3321 4.31302C14.435 4.37638 14.5517 4.41371 14.6724 4.42239L16.1272 4.53003C16.9137 4.58732 17.596 5.08125 17.8929 5.81128L18.4436 7.16284C18.4892 7.27439 18.5608 7.37335 18.6528 7.45191L19.7679 8.39288C20.3694 8.90243 20.6298 9.70321 20.4415 10.4675L20.0943 11.8833C20.0647 12.0014 20.0647 12.1246 20.0943 12.2427L20.4415 13.6568C20.6298 14.4228 20.3699 15.2249 19.7679 15.7332L18.6528 16.6724C18.5604 16.751 18.4888 16.8508 18.4436 16.9636L17.8929 18.313C17.5947 19.0439 16.9137 19.5387 16.1272 19.596L14.6724 19.7019C14.5517 19.711 14.435 19.7492 14.3321 19.813L13.0942 20.5825C12.4237 20.9983 11.5808 20.9983 10.9102 20.5825L9.67237 19.813C9.56951 19.7492 9.45276 19.711 9.3321 19.7019L7.87724 19.596C7.09078 19.5387 6.40849 19.0431 6.11161 18.313L5.56083 16.9636C5.51569 16.8508 5.44408 16.751 5.35206 16.6724L4.23661 15.7332C3.63418 15.2236 3.37463 14.4215 3.563 13.6568L3.91022 12.2427C3.93974 12.1246 3.93974 12.0014 3.91022 11.8833L3.563 10.4693C3.37463 9.70321 3.63461 8.90112 4.23661 8.39288L5.35206 7.45364C5.44408 7.37508 5.51569 7.27526 5.56083 7.16284L6.11161 5.81302C6.40979 5.08211 7.09078 4.58732 7.87724 4.53003L9.3321 4.42413C9.45276 4.41501 9.56951 4.37682 9.67237 4.31302L10.9102 3.54349C11.2457 3.33515 11.6242 3.23099 12.0022 3.23099ZM14.2366 7.05347C13.9627 7.06085 13.7149 7.21753 13.5903 7.46145L9.08991 15.9615C8.95363 16.1989 8.95753 16.4918 9.10033 16.7258C9.24312 16.9597 9.5018 17.0973 9.77524 17.0843C10.0491 17.0717 10.2939 16.9107 10.4141 16.6646L14.9141 8.16458C15.0439 7.9289 15.0374 7.64201 14.8976 7.41241C14.7574 7.18281 14.5053 7.04609 14.2366 7.05347ZM8.99052 8.05347C8.57689 8.05954 8.24703 8.39939 8.25224 8.81302V10.313C8.24833 10.5834 8.39069 10.8352 8.6242 10.9714C8.8577 11.1077 9.14677 11.1077 9.38027 10.9714C9.61378 10.8352 9.75614 10.5834 9.75224 10.313V8.81302C9.75484 8.61033 9.67541 8.41545 9.53175 8.27222C9.38852 8.12899 9.19321 8.05 8.99052 8.05347ZM14.9905 13.053C14.5769 13.0595 14.247 13.3994 14.2522 13.813V15.313C14.2483 15.5834 14.3907 15.8352 14.6242 15.9714C14.8577 16.1077 15.1468 16.1077 15.3803 15.9714C15.6138 15.8352 15.7561 15.5834 15.7522 15.313V13.813C15.7548 13.6103 15.6754 13.4154 15.5317 13.2722C15.3885 13.129 15.1932 13.05 14.9905 13.05347'
      fill='currentColor'
    />
  ),
});

type PlansPromotionsBannerProps = LinkBoxProps;

export function PlansPromotionsBanner({ ...props }: PlansPromotionsBannerProps) {
  const { isLoading, data } = usePromotion();
  const priceCardsBanner = data?.priceCardsBanner;

  if (isLoading || !priceCardsBanner) return null;

  return (
    <LinkBox
      alignItems='center'
      aria-labelledby='promotion-banner-title'
      as='aside'
      borderRadius='4px'
      color='white'
      display='flex'
      gap={2}
      marginBottom={{ base: '12px', md: 0 }}
      marginX='auto'
      position='relative'
      width='fit-content'
      {...props}
    >
      <PersonalizedDiscountIcon boxSize={{ base: '16px', md: '24px' }} flexShrink={0} aria-hidden />
      <Text fontSize={{ base: 'sm', md: 'lg' }} fontWeight='400' id='promotion-banner-title' lineHeight='1.5'>
        {priceCardsBanner.text}{' '}
        {Boolean(priceCardsBanner.linkUrl && priceCardsBanner.linkLabel) && (
          <LinkOverlay
            _focusVisible={{ boxShadow: 'outline' }}
            _visited={{ color: '#89E6FF' }}
            color='#89E6FF'
            href={priceCardsBanner.linkUrl!}
            textDecoration='underline'
            whiteSpace='nowrap'
            onClick={() =>
              trackEvent({
                type: 'click',
                label: 'promotion_banner_clicked',
                name: 'Plans CTA Clicked',
              })
            }
          >
            {priceCardsBanner.linkLabel}
          </LinkOverlay>
        )}
      </Text>
    </LinkBox>
  );
}
